<template>
    <div>
        <v-container grid-list-lg fluid>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-card class="pa-4 mb-4">
                        <v-card-title>Tổng hợp đánh giá nhân viên</v-card-title>
                        <v-data-table :headers="summary_headers" hide-default-footer :sortable="false"
                            :items="staff_summary" :server-items-length="staff_summary ? staff_summary.length : 0"
                            :loading="loading" :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-start">{{ item.Username }}</td>
                                    <td class="text-end">{{ item.AvgRate | currency('', 2) }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>

                <v-divider></v-divider>

                <v-flex lg12 v-if="adminRole || paymentRole">
                    <v-card class="pa-4">
                        <v-card-title>Chi tiết đánh giá khách hàng</v-card-title>
                        <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter"
                            v-on:quickFilter="quickFilter"></hpo-filter>
                        <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                            :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                            :loading="loading" :mobile-breakpoint="100">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td class="text-start">{{ item.StaffName }}</td>
                                    <td class="text-start">{{ item.CustomerName }}</td>
                                    <td class="text-end">{{ item.Rate | currency }}</td>
                                    <td class="text-start">{{ item.Comment }}</td>
                                    <td class="text-end">{{ item.CreatedDate | display_date }}</td>
                                    <td class="text-end">{{ item.ModifiedDate | display_date }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";
import moment from "moment"
export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "bao-cao-danh-gia-nhan-vien",
            pagination: {  ...configs.PAGINATION,  sortBy: ["ID"]  },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            headers: [
                {
                    text: "Nhân viên",
                    value: "StaffName",
                    sortable: true,
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Khách hàng",
                    value: "CustomerName",
                    sortable: true,
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Điểm đánh giá",
                    value: "Rate",
                    sortable: true,
                    filterable: true,
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Comment",
                    value: "Comment",
                    sortable: true,
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Ngày đánh giá",
                    value: "CreatedDate",
                    sortable: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Ngày cập nhật",
                    value: "ModifiedDate",
                    sortable: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                }
            ],
            summary_headers: [
                {
                    text: "Nhân viên",
                    value: "StaffName",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Điểm trung bình",
                    value: "AvgRate",
                    align: "end",
                    dataType: configs.DATA_TYPE["Number"]
                }
            ],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.report.userRateReport.data,
            total_rows: state => state.report.userRateReport.total,
            staff_summary: state => state.report.userRateReport.summary,
            loading: state => state.report.loading
        }),
        computedStartDateFormatted() {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted() {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        paymentRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
        }
    },
    methods: {
        filter_data: function () {
            var param = {
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
                pagination: this.pagination,
                filter: this.filterConditions,
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("report/getUserRateReport", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
<style scoped>
.rate-p {
    margin-bottom: 0px;
    margin-top: 16px;
}

.rate-p2 {
    margin-bottom: 16px;
    margin-top: 8px;
    color: rgb(168, 168, 168);
}
</style>